import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from '../../../../styles/icons/logos/logo.module.scss';

import logo from '../../../../img/iga/tablee_logo.svg';

const propTypes = {
    className: PropTypes.string,
};

function IgaTableeLogo({ className = null }) {
    return (
        <img
            src={logo}
            className={classNames([styles.container, className])}
            alt="Defis Littéraires"
        />
    );
}

IgaTableeLogo.propTypes = propTypes;

export default IgaTableeLogo;
